import { render } from "./Globe.vue?vue&type=template&id=9e386188&scoped=true"
import script from "./Globe.vue?vue&type=script&lang=js"
export * from "./Globe.vue?vue&type=script&lang=js"

import "./Globe.vue?vue&type=style&index=0&id=9e386188&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9e386188"

export default script